import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PhenobleLogo  from '../assets/images/Phenoble2.png'
import classes from './MainNavigation.module.css'
import { FaWhatsapp } from 'react-icons/fa'

const MainNavigation = () => {
  const location = useLocation();
  const handleNavbarToggler = () => {
    // Collapse the navbar on mobile after navigation
    const collapse = document.getElementById('navbarTogglerDemo02');
    if (collapse && collapse.classList.contains('show')) {
      collapse.classList.remove('show');
    }
  }
  return (
    <nav className={classes.navbar + ' navbar navbar-expand-md fixed-top'}>
      <div className="container-fluid">
        <NavLink className={classes.brand} to="/">
          <img src={PhenobleLogo} alt='header-logo' className={classes.logo} />
        </NavLink>
        
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarTogglerDemo02">
            <ul className={classes.navList + ' navbar-nav me-auto pt-3 mb-1 mb-lg-0 justify-content-end'}>
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} aria-current="page" to="/" className={classes.aLink}>Home</NavLink>
                </li>
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/services" className={classes.aLink}>Services</NavLink>
                </li>
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/about" className={classes.aLink}>About</NavLink>
                </li>
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/career" className={classes.aLink}>Career</NavLink>
                </li>
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/blog" className={classes.aLink}>
                        Blogs
                    </NavLink>
                </li>
                {/* <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/victoryvault" className={classes.aLink}>Victory Vault</NavLink>
                </li> */}
                <li className={classes.list}>
                    <NavLink onClick={handleNavbarToggler} to="/contact" className={classes.aLink}>Contact</NavLink>
                </li>
            </ul>
            <div className={classes.ctaWrap}>
                <NavLink to="/contact" className={classes.ctaBtn}>
                    Unlock a Free Strategy Consultation
                </NavLink>
                <a
                    href="https://wa.me/917850952954"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.whatsappBtn}
                    aria-label="Chat on WhatsApp"
                >
                    <FaWhatsapp size={24} />
                </a>
            </div>
        </div>
      </div>
    </nav>
  )
}

export default MainNavigation